import { AssetVariable } from '@iot-platform/models/i4b';

export abstract class AbstractGridAssetVariableConfigureReadPopupService {
  abstract updateAssetVariableThresholds(assetVariable: AssetVariable): void;
}
